/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// global elements
import Header from 'components/shared/header/header_container';
import Body from 'components/shared/body/body_container';
import RewardsIndicator from 'components/shared/rewardsindicator/rewardsindicator_container';
import Footer from 'components/shared/footer/footer_container';
import Background from 'components/shared/background/background_container';
import Skip from 'components/shared/skip/skip_container';
// STYLES
// (css-in-js, imported as JS from external file, turned into CSS via library used in utils)
import styles from 'components/shared/structure/structure_styles';
import { createStyles } from 'utils/styles';
import LoadingOverlay from 'components/shared/loading/loading_container';
const sheet = createStyles(styles, {link:false});



/* ========== ~~~~~~~~~~ STRUCTURE : (header/body/footer/etc) ~~~~~~~~~~ ========== */
// STATELESS FUNCTIONAL COMPONENT
// used to create markup structure and render UI
// doesn't need all the lifecycle functions attached
const Structure = (props) => {
    return(
        <div className={`${sheet.classes.structure}`}>
            <Header contentId={props.contentId} />
            <Body contentId={props.contentId} markup={props.markup} />
            <Footer contentId={props.contentId}>
                <Skip contentId={props.contentId}/>
            </Footer>
            {props.rewardsEnabled && props.rewardsPermitted ? <RewardsIndicator contentId={props.contentId} /> : null}
            <Background
                contentId={props.contentId}
                screenBGImg={props.screenBGImg !== undefined ? props.screenBGImg : null}
                screenBGColor={props.screenBGColor !== undefined ? props.screenBGColor : null}
            />
            <LoadingOverlay contentId={props.contentId} />
        </div>
    );
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default Structure;
